<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modal.title"
    @on-confirm="save"
    @on-cancel="hide"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    maxWidth="50%"
  >
    <div v-for="item in paramItems" :key="item.uuid">
      <v-text-field :label="item.name" v-model="item.value"></v-text-field>
    </div>
  </base-modal>
</template>
<script>
export default {
    name: 'ListFieldParamsModal',
    data() {
        return {
            modal: {
                title: this.$t('Parameters'),
                key: 'listFieldParamsModalKey',
            },
            open: false,
            paramItems: [],
        };
    },
    methods: {
        edit(paramItems) {
            this.paramItems = paramItems;
            this.show();
        },
        async save() {
            this.$emit('on-saved', this.paramItems);
            this.hide();
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        },
    },
};
</script>
